import React, { FC, isValidElement, ReactElement } from 'react';
import { useFocusTrap, Settings } from './useFocusTrap';

// TODO FI-1462 create new FocusTrap package, write docs, write test, write storybook

export const FocusTrap: FC<{ children: ReactElement } & Settings> = ({
    children,
    active,
    paused,
    options,
}) => {
    const child = React.Children.only(children);
    const barrierRef = useFocusTrap({ active, paused, options });
    if (isValidElement(child)) {
        return React.cloneElement(child, { ref: barrierRef });
    } else {
        throw new Error('Focus trap child is not a valid ReactElement');
    }
};
